/**
 * Сравнивает JSON-данные по содержимому: порядок ключей не важен,
 * undefined-поля объектов равны отсутствующим, порядок элементов массивов важен.
 */
export function isSameJsonValue(left: unknown, right: unknown): boolean {
	if (left === right) {
		return true;
	}
	if (left === null || right === null || typeof left !== "object" || typeof right !== "object") {
		return false;
	}

	if (Array.isArray(left)) {
		if (!Array.isArray(right) || left.length !== right.length) {
			return false;
		}
		for (let index = 0; index < left.length; index++) {
			if (!isSameJsonValue(left[index], right[index])) {
				return false;
			}
		}
		return true;
	}
	if (Array.isArray(right)) {
		return false;
	}

	const leftObject = left as Record<string, unknown>;
	const rightObject = right as Record<string, unknown>;
	for (const key of Object.keys(leftObject)) {
		if (leftObject[key] === undefined) {
			continue;
		}
		if (!Object.prototype.hasOwnProperty.call(rightObject, key) || !isSameJsonValue(leftObject[key], rightObject[key])) {
			return false;
		}
	}
	for (const key of Object.keys(rightObject)) {
		if (rightObject[key] === undefined) {
			continue;
		}
		if (!Object.prototype.hasOwnProperty.call(leftObject, key) || leftObject[key] === undefined) {
			return false;
		}
	}
	return true;
}
